// Arabic privacy & integrations strings — DEVELOPMENT DRAFT by Claude (PD-011); unreviewed until decision H-10.
import type { enPrivacy } from './en-privacy.ts';
import type { Message } from './types.ts';

export const arPrivacy: { readonly [K in keyof typeof enPrivacy]: Message } = {
  'api.privacyRetentionUnconfigured': 'تحتاج كل فئة سجلات إلى مدة احتفاظ معتمدة قبل نشر القواعد.',
  'api.privacyNoPublishedRetention': 'انشر قواعد الاحتفاظ قبل التخطيط لعملية حذف.',
  'api.privacyFourEyes': 'يجب أن يطبّق عملية الحذف شخص غير الذي خطط لها.',
  'api.privacyDryRun': 'التشغيل التجريبي معاينة فقط. خطّط لتشغيل جديد لتطبيقه.',
  'api.privacyErasureViaRequest': 'طبّق المحو من طلب صاحب البيانات الخاص به.',
  'api.privacyDraftExists': 'توجد مسودة لهذا الغرض بالفعل. اعتمدها أو استبدلها أولاً.',
  'api.privacyRequestState': 'هذه الخطوة غير متاحة بينما حالة الطلب {status}.',
  'api.privacyNotVerified': 'تحقّق من هوية مقدّم الطلب أولاً.',
  'api.privacyContactOnly': 'لا يكفي تطابق وسيلة اتصال مشتركة وحدها لربط هذا السجل. يجب أن يتطابق الاسم أو البريد الإلكتروني أيضاً.',
  'api.privacyNoMatch': 'هذا السجل لا يطابق بيانات مقدّم الطلب.',
  'api.privacyNoSubjects': 'اربط سجلاً مطابقاً واحداً على الأقل أولاً.',
  'api.privacyNoExport': 'جهّز ملف التصدير أولاً.',
  'api.privacyExportUnavailable': 'ملف التصدير هذا غير مُفرج عنه أو انتهت صلاحيته.',
  'api.privacyNoPlan': 'خطّط لعملية المحو أولاً.',
  'api.apiClientNameTaken': 'يوجد عميل واجهة برمجة نشط بهذا الاسم.',
  'api.apiRateLimited': 'طلبات كثيرة جداً. حاول مرة أخرى بعد قليل.',
  'api.connectorNotEnabled': 'فعّل الموصل أولاً.',
  'api.connectorTestRequired': 'نفّذ اختبار اتصال ناجحاً لهذا الإعداد قبل تفعيله.',
  'api.connectorUnknownAdapter': 'هذا المحوّل غير متاح في هذا الإصدار.',
  'api.operationNotUnknown': 'لا تتم المطابقة إلا للعمليات ذات النتيجة غير المعروفة.',
  'api.webhookDestination': 'عنوان خطاف الويب هذا غير مسموح به.',
  'api.webhookDisabled': 'هذا الاشتراك معطّل.',
  'v.reasonShort': 'اكتب سبباً من 3 أحرف على الأقل.',
  'v.acknowledgeRequired': 'أكّد أنك تدرك أن هذا الإجراء لا يمكن التراجع عنه.',
  'v.apiScopeDuplicate': 'يُذكر كل نطاق مرة واحدة فقط.',
  'v.apiScopeForbidden': 'لا يمكنك منح هذا الوصول.',
  'v.apiScopeHumanOnly': 'هذا الإجراء مخصص للأشخاص فقط ولا يمكن منحه لعميل واجهة برمجة.',
  'v.apiScopeInvalid': 'اختر إجراءً ونطاقاً صالحين.',
  'v.privacyContactRequired': 'سجّل بريداً إلكترونياً أو رقم هاتف للرد.',
  'v.privacyExtensionMax': 'يمكن إضافة {max} يوماً كحد أقصى.',
  'v.privacyHoldOwner': 'اختر شخصاً نشطاً مالكاً للتجميد.',
  'v.privacyNoticeRequired': 'يحتاج غرض الموافقة إلى الإشعار الذي يسجّل الموافقة.',
  'v.secretRefInvalid': 'استخدم مرجعاً سرياً مثل env:NAME أو vault:path#key.',
  'v.secretRefRequired': 'لا تُخزَّن الأسرار هنا أبداً. استخدم مرجعاً سرياً بدلاً من ذلك.',
  'v.webhookEventForbidden': 'لا يمكنك قراءة السجلات التي يصفها هذا الحدث.',
  'v.webhookEventUnknown': 'نوع حدث غير معروف.',
  'v.webhookUrl.invalid_url': 'أدخل عنواناً كاملاً مثل https://example.com/hooks.',
  'v.webhookUrl.scheme': 'استخدم https (يُسمح بـ http فقط للمستقبلات المحلية خارج بيئة الإنتاج).',
  'v.webhookUrl.credentials_in_url': 'لا تضع بيانات اعتماد في العنوان.',
  'v.webhookUrl.blocked_address': 'العناوين الداخلية والمحلية للرابط وعناوين البيانات الوصفية غير مسموح بها.',
  'v.webhookUrl.port': 'استخدم منفذاً صالحاً.',
  'specialist.privacy-administrator': 'مسؤول الخصوصية (الاحتفاظ والأغراض والأساس القانوني)',
  'privacy.request.status.received': 'مستلَم',
  'privacy.request.status.verified': 'تم التحقق',
  'privacy.request.status.export_ready': 'التصدير جاهز للمراجعة',
  'privacy.request.status.released': 'تم الإفراج عن التصدير',
  'privacy.request.status.erasure_planned': 'المحو مخطط له',
  'privacy.request.status.erasing': 'جارٍ المحو',
  'privacy.request.status.completed': 'مكتمل',
  'privacy.request.status.partial': 'مكتمل جزئياً',
  'privacy.request.status.rejected': 'مرفوض',
  'privacy.request.status.withdrawn': 'مسحوب',

  // ------------------------------------------------------------ UI (privacy and integrations pages)
  'pv.title': "الخصوصية ودورة حياة البيانات",
  'pv.intro': "راجع الهوية والتجميد ونتائج كل مخزن قبل إكمال الطلب.",
  'pv.legalTitle': "القيم القانونية قرارات يتخذها المالك",
  'pv.legalBody': "مدد الاحتفاظ والأسس القانونية ومواعيد الرد هنا إعدادات قابلة للتغيير. القيم الافتراضية الهندسية مؤقتة وليست استشارة قانونية، ولا تدّعي هذه الصفحة الامتثال لأي قانون.",
  'pv.tabsLabel': "أقسام الخصوصية",
  'pv.tab.requests': "طلبات أصحاب البيانات",
  'pv.tab.retention': "الاحتفاظ والأغراض",
  'pv.tab.holds': "التجميد ومعالجة النسخ الاحتياطية",
  'pv.tab.purges': "مهام الحذف",
  'pv.tab.history': "سجل الإجراءات",
  'pv.col.action': "الإجراء",
  'pv.masked': "التفاصيل مخفية",
  'pv.overdue': "متأخر",
  'pv.hold.active': "تجميد نشط",
  'pv.hold.none': "لا تجميد",
  'pv.req.title': "سجل طلبات أصحاب البيانات",
  'pv.req.intro': "تبقى الطلبات غير مكتملة ما دام أي مخزن إلزامي دون حل.",
  'pv.req.new': "طلب جديد من صاحب بيانات",
  'pv.req.newHint': "سجّل من طلب وكيف. يتم التحقق من الهوية في خطوة منفصلة.",
  'pv.req.empty': "لا توجد طلبات ضمن نطاقك.",
  'pv.req.col.reference': "المرجع / مقدّم الطلب",
  'pv.req.col.type': "الطلب",
  'pv.req.col.status': "الحالة",
  'pv.req.col.due': "الاستحقاق",
  'pv.req.col.hold': "التجميد",
  'pv.req.review': "مراجعة الطلب",
  'pv.req.unverified': "لم يتم التحقق من الهوية",
  'pv.req.type': "نوع الطلب",
  'pv.req.site': "الموقع",
  'pv.req.siteHint': "تحتاج الطلبات على مستوى المؤسسة إلى صلاحية خصوصية على مستوى المؤسسة لمراجعتها.",
  'pv.req.requesterName': "اسم مقدّم الطلب",
  'pv.req.requesterEmail': "بريد الرد",
  'pv.req.requesterPhone': "هاتف الرد",
  'pv.req.receivedVia': "وصل عبر",
  'pv.req.create': "تسجيل الطلب",
  'pv.req.requester': "مقدّم الطلب",
  'pv.req.contact': "الاتصال",
  'pv.req.received': "تاريخ الاستلام",
  'pv.req.identity': "الهوية",
  'pv.req.holdNote': "يشمل تجميد نشط صاحب البيانات هذا. تبقى السجلات المجمّدة حتى يرفع شخص مخوّل التجميد.",
  'pv.req.method': "طريقة التحقق",
  'pv.req.whatChecked': "ما الذي تم التحقق منه",
  'pv.req.whatCheckedHint': "صف عملية التحقق. لا تسجّل أرقام المستندات أو نسخها أبداً.",
  'pv.req.linkHint': "اربط فقط السجلات المطابقة لمقدّم الطلب الذي تم التحقق منه. يُرفض الربط برقم هاتف مشترك وحده.",
  'pv.req.linked': { zero: "لا توجد سجلات مرتبطة", one: "سجل واحد مرتبط", two: "سجلان مرتبطان", few: "{count} سجلات مرتبطة", many: "{count} سجلاً مرتبطاً", other: "{count} سجل مرتبط" },
  'pv.req.isLinked': "مرتبط",
  'pv.req.link': "ربط السجل",
  'pv.req.linkFirst': "اربط سجل صاحب البيانات أولاً.",
  'pv.req.exports': "ملفات التصدير",
  'pv.req.download': "تنزيل",
  'pv.req.expires': "متاح حتى {at}",
  'pv.step.verify': "تسجيل التحقق من الهوية",
  'pv.step.link': "ربط السجلات المطابقة",
  'pv.step.prepareExport': "تجهيز التصدير للمراجعة",
  'pv.step.releaseExport': "الإفراج عن التصدير بعد مراجعته",
  'pv.step.planErasure': "التخطيط للمحو",
  'pv.step.applyErasure': "تطبيق المحو",
  'pv.step.correct': "تطبيق التصحيحات",
  'pv.step.complete': "إكمال الطلب",
  'pv.step.extend': "تمديد الموعد 14 يوماً",
  'pv.step.withdraw': "تسجيل سحب الطلب",
  'pv.step.reject': "رفض الطلب",
  'pv.ackIrreversible': "أدرك أن هذا يحذف البيانات أو يجعلها مجهولة الهوية ولا يمكن التراجع عنه.",
  'pv.applyHint': "يُعاد فحص التجميد لكل عنصر عند تنفيذه. يجب أن يطبّق شخص آخر ما خططت له.",
  'pv.run.title': "الخطة لكل مخزن",
  'pv.item.class': "فئة البيانات",
  'pv.item.store': "المخزن",
  'pv.item.method': "الإجراء",
  'pv.item.status': "النتيجة",
  'pv.ret.title': "الاحتفاظ حسب فئة البيانات",
  'pv.ret.intro': "تحتاج كل فئة إلى مدة معتمدة قبل نشر القواعد.",
  'pv.ret.loadDefaults': "ملء الفراغات بالقيم الافتراضية الهندسية",
  'pv.ret.publish': "نشر المسودة",
  'pv.ret.discard': "تجاهل المسودة",
  'pv.ret.problems': { zero: "لا توجد فئات بلا مدة.", one: "فئة واحدة ما زالت تحتاج إلى مدة.", two: "فئتان ما زالتا تحتاجان إلى مدة.", few: "{count} فئات ما زالت تحتاج إلى مدة.", many: "{count} فئة ما زالت تحتاج إلى مدة.", other: "{count} فئة ما زالت تحتاج إلى مدة." },
  'pv.ret.class': "فئة البيانات",
  'pv.ret.trigger': "بداية الاحتساب",
  'pv.ret.published': "المنشور (الإصدار {number})",
  'pv.ret.draft': "المسودة",
  'pv.ret.unconfigured': "غير مُعدّ",
  'pv.ret.days': { zero: "0 يوم", one: "يوم واحد", two: "يومان", few: "{count} أيام", many: "{count} يوماً", other: "{count} يوم" },
  'pv.ret.engineeringDefault': "افتراضي هندسي",
  'pv.ret.noStoreYet': "لا يوجد مخزن بيانات بعد",
  'pv.ret.daysFor': "عدد الأيام لـ {name}",
  'pv.ret.saveDraft': "حفظ المسودة",
  'pv.ret.noInvent': "لا تُفترض أي مدة: الفئة الفارغة تمنع النشر.",
  'pv.pur.title': "الأغراض والأساس القانوني",
  'pv.pur.intro': "يسجّل كل غرض معالجة أساسه المعتمد؛ وترتبط أغراض الموافقة بالإشعار الذي يمثّل قبوله سجل الموافقة.",
  'pv.pur.empty': "لا توجد أغراض مسجلة بعد.",
  'pv.pur.purpose': "الغرض",
  'pv.pur.basis': "الأساس القانوني",
  'pv.pur.consent': "إيصالات الموافقة",
  'pv.pur.consentLine': "الإصدار {version} ({locale}): {accepted} قبول، {declined} رفض",
  'pv.pur.withdrawals': { zero: "لا سحب", one: "سحب واحد", two: "سحبان", few: "{count} حالات سحب", many: "{count} حالة سحب", other: "{count} حالة سحب" },
  'pv.pur.approve': "اعتماد",
  'pv.pur.code': "رمز الغرض",
  'pv.pur.nameEn': "الاسم (بالإنجليزية)",
  'pv.pur.nameAr': "الاسم (بالعربية)",
  'pv.pur.classes': "فئات البيانات",
  'pv.pur.classesHint': "رموز الفئات مفصولة بفواصل، مثل visit_metadata, documents.",
  'pv.pur.notice': "مفتاح إشعار الموافقة",
  'pv.pur.draft': "صياغة غرض",
  'pv.set.title': "مواعيد الطلبات والضمانات",
  'pv.set.defaults': "تُستخدم القيم الافتراضية الهندسية؛ المواعيد القانونية قرار يتخذه المالك.",
  'pv.set.organisation': "قيم حددتها مؤسستك.",
  'pv.set.requestResponseDays': "أيام الرد على الطلب",
  'pv.set.requestExtensionDays': "الحد الأقصى للتمديد (أيام)",
  'pv.set.exportDownloadDays': "مدة إتاحة تنزيل التصدير (أيام)",
  'pv.set.anonymityThreshold': "أصغر مجموعة يُحتفظ بها",
  'pv.set.purgeFourEyes': "يجب أن يطبّق شخص ثانٍ كل عملية حذف",
  'pv.set.noAutoApply': "يجهّز التخطيط المجدول عمليات الحذف فقط؛ ويطبّقها دائماً شخص.",
  'pv.sen.title': "صلاحيات الحقول الحساسة",
  'pv.sen.intro': "تحتاج القراءة والكشف والتصدير لكل فئة إلى صلاحيات خاصة بها؛ ولا يمنح الوصول العام إلى الزيارات أياً منها.",
  'pv.sen.field': "فئة الحقل",
  'pv.sen.read': "قراءة",
  'pv.sen.reveal': "كشف",
  'pv.sen.export': "تصدير",
  'pv.sen.yours': "أنت: {value}",
  'pv.hold.title': "التجميد القانوني والتحقيقي",
  'pv.hold.intro': "يوقف التجميد الحذف المجدول للسجلات الواقعة في نطاقه فقط. رفع التجميد صلاحية منفصلة.",
  'pv.hold.new': "وضع تجميد",
  'pv.hold.newHint': "اجعل النطاق ضيقاً؛ المالك والسبب وتاريخ المراجعة مطلوبة.",
  'pv.hold.empty': "لا يوجد تجميد.",
  'pv.hold.scope': "النطاق",
  'pv.hold.reason': "السبب",
  'pv.hold.owner': "المالك المسؤول",
  'pv.hold.ownerHint': "مرجع المستخدم للشخص المسؤول عن هذا التجميد.",
  'pv.hold.review': "المراجعة بحلول",
  'pv.hold.target': "مرجع السجل",
  'pv.hold.targetHint': "مرجع الشخص أو الزيارة (المعرّف).",
  'pv.hold.place': "وضع التجميد",
  'pv.hold.release': "رفع التجميد",
  'pv.hold.releaseWarning': "بعد الرفع، يمكن لقواعد الاحتفاظ وخطط المحو المعتمدة حذف هذه السجلات.",
  'pv.bak.title': "معالجة النسخ الاحتياطية والاستعادة",
  'pv.bak.intro': "تترك السجلات الممحوة شواهد تحتوي على المعرّفات فقط. بعد أي استعادة، يُعاد تطبيق الشواهد قبل إعادة فتح الخدمة.",
  'pv.bak.empty': "لا توجد شواهد بعد.",
  'pv.bak.count': "الشواهد",
  'pv.bak.reapplied': "آخر إعادة تطبيق",
  'pv.bak.never': "أبداً",
  'pv.bak.foot': "تتبع مدة صلاحية النسخ الاحتياطية سياسة النشر (قرار المالك)؛ وتُمحى النسخ المستعادة مجدداً بتشغيل الشواهد.",
  'pv.pg.title': "مهام حذف الاحتفاظ",
  'pv.pg.intro': "خطّط أو نفّذ تشغيلاً تجريبياً لمعاينة المستحق؛ يطبّق شخص العملية، ويعرض السجل نتيجة كل مخزن.",
  'pv.pg.kind': "نوع التشغيل",
  'pv.pg.dryRun': "تشغيل تجريبي",
  'pv.pg.plan': "تخطيط",
  'pv.pg.empty': "لا توجد عمليات حذف بعد.",
  'pv.pg.run': "التشغيل",
  'pv.pg.items': "العناصر",
  'pv.pg.open': "فتح",
  'pv.pg.scheduled': "مجدول",
  'pv.pg.engineeringDefaults': { zero: "لا فئات تستخدم القيم الافتراضية", one: "فئة واحدة تستخدم قيمة افتراضية هندسية", two: "فئتان تستخدمان قيماً افتراضية هندسية", few: "{count} فئات تستخدم قيماً افتراضية هندسية", many: "{count} فئة تستخدم قيماً افتراضية هندسية", other: "{count} فئة تستخدم قيماً افتراضية هندسية" },
  'pv.pg.aggregates': "المجاميع المحتفظ بها: {count} مجموعة؛ {risky} مجموعة صغيرة تفقد التفاصيل المعرِّفة.",
  'pv.pg.apply': "تطبيق الحذف",
  'pv.pg.retry': "إعادة محاولة العناصر الفاشلة",
  'pv.pg.cancel': "إلغاء الخطة",
  'pv.his.title': "سجل إجراءات الخصوصية",
  'pv.his.intro': "التصدير والمحو والتجميد وتغييرات الاحتفاظ وعمليات الكشف، بمعرّفات آمنة فقط.",
  'pv.his.empty': "لا توجد إجراءات خصوصية مسجلة.",
  'pv.his.when': "الوقت",
  'pv.his.action': "الإجراء",
  'pv.his.record': "السجل",
  'pv.his.outcome': "النتيجة",
  'pv.field.givenName': "الاسم الأول",
  'pv.field.familyName': "اسم العائلة",
  'pv.field.email': "البريد الإلكتروني",
  'pv.field.phone': "الهاتف",
  'pv.type.export': "الاطلاع / التصدير",
  'pv.type.correction': "التصحيح",
  'pv.type.erasure': "المحو",
  'pv.via.email': "البريد الإلكتروني",
  'pv.via.web': "نموذج إلكتروني",
  'pv.via.in_person': "حضورياً",
  'pv.via.post': "البريد",
  'pv.via.phone': "الهاتف",
  'pv.via.other': "أخرى",
  'pv.method.document_sighted': "تمت معاينة المستند",
  'pv.method.authenticated_channel': "قناة موثّقة",
  'pv.method.known_contact_challenge': "تحقق عبر وسيلة اتصال معروفة",
  'pv.method.authorised_representative': "ممثل مفوَّض",
  'pv.method.delete': "حذف",
  'pv.method.anonymise': "إخفاء الهوية",
  'pv.method.redact': "تنقيح",
  'pv.basis.email': "البريد الإلكتروني",
  'pv.basis.phone': "الهاتف",
  'pv.basis.name': "الاسم",
  'pv.basis.legal.consent': "الموافقة",
  'pv.basis.legal.contract': "العقد",
  'pv.basis.legal.legal_obligation': "التزام قانوني",
  'pv.basis.legal.vital_interests': "مصالح حيوية",
  'pv.basis.legal.public_interest': "المصلحة العامة",
  'pv.basis.legal.legitimate_interests': "مصالح مشروعة",
  'pv.refusal.contact_only': "وسيلة اتصال فقط — مرفوض",
  'pv.refusal.no_match': "لا تطابق",
  'pv.export.prepared': "مُجهّز — بانتظار المراجعة",
  'pv.export.released': "مُفرج عنه",
  'pv.export.superseded': "مستبدَل",
  'pv.export.purged': "محذوف",
  'pv.count.people': "الأشخاص",
  'pv.count.visits': "الزيارات",
  'pv.count.presenceEvents': "أحداث الحضور",
  'pv.count.acknowledgements': "الإقرارات",
  'pv.count.documents': "المستندات",
  'pv.count.messages': "الرسائل",
  'pv.count.photos': "الصور",
  'pv.count.history': "قيود السجل",
  'pv.count.profileFields': "حقول الملف الشخصي",
  'pv.count.affiliations': "الانتماءات إلى المؤسسات",
  'pv.count.profileLinks': "قرارات ربط الملفات الشخصية",
  'pv.count.organisationContacts': "إدخالات جهات اتصال المؤسسات",
  'pv.count.rosterRows': "صفوف قوائم الحضور المرحلية",
  'pv.count.profileFieldsWithheld': "حقول ملف شخصي محجوبة للمراجعة",
  'pv.exception.currently_onsite': "موجود حالياً في الموقع",
  'pv.exception.active_visit': "الزيارة لم تنتهِ بعد",
  'pv.exception.shared_record': "مشترك مع أشخاص آخرين",
  'pv.item.pending': "قيد الانتظار",
  'pv.item.done': "تم",
  'pv.item.held': "مجمّد",
  'pv.item.excepted': "استثناء",
  'pv.item.failed': "فشل",
  'pv.run.status.planned': "مخطط",
  'pv.run.status.applying': "قيد التطبيق",
  'pv.run.status.completed': "مكتمل",
  'pv.run.status.partial': "مكتمل جزئياً",
  'pv.run.status.cancelled': "ملغى",
  'pv.pg.kind.retention': "حذف حسب الاحتفاظ",
  'pv.pg.kind.anonymisation': "إخفاء الهوية",
  'pv.pg.kind.erasure': "محو بطلب صاحب البيانات",
  'pv.pur.status.draft': "مسودة",
  'pv.pur.status.approved': "معتمد",
  'pv.pur.status.retired': "متقاعد",
  'pv.hold.kind.person': "شخص",
  'pv.hold.kind.visit': "زيارة",
  'pv.hold.kind.site': "موقع",
  'pv.hold.kind.record_class': "فئة بيانات",
  'pv.hold.status.active': "نشط",
  'pv.hold.status.released': "مرفوع",
  'pv.store.database': "قاعدة البيانات",
  'pv.store.object_store': "مخزن الملفات",
  'pv.trigger.visit_end': "نهاية الزيارة",
  'pv.trigger.record_created': "إنشاء السجل",
  'pv.trigger.request_closed': "إغلاق الطلب",
  'pv.trigger.last_activity': "آخر نشاط",
  'pv.his.actor.user': "شخص",
  'pv.his.actor.automation': "عميل واجهة برمجة",
  'pv.his.actor.system': "النظام",
  'pv.his.actor.anonymous': "غير موثّق",
  'pv.his.actor.device': "جهاز",
  'pv.sen.class.identity_document': "وثائق الهوية",
  'pv.sen.class.identity_number': "أرقام الهوية",
  'pv.sen.class.photo': "الصور الشخصية",
  'pv.sen.class.signature': "التوقيعات",
  'pv.sen.class.private_note': "الملاحظات الخاصة",
  'pv.sen.class.contact': "بيانات الاتصال",
  'pv.class.visit_metadata': "بيانات الزيارة الوصفية",
  'pv.class.identity_fields': "حقول الهوية",
  'pv.class.id_images': "صور الهوية",
  'pv.class.identity_evidence': "قيم أدلة الهوية",
  'pv.class.photos': "الصور",
  'pv.class.signatures': "التوقيعات",
  'pv.class.documents': "المستندات",
  'pv.class.access_events': "أحداث الدخول",
  'pv.class.private_notes': "الملاحظات الخاصة",
  'pv.class.messages': "الرسائل",
  'pv.class.plate_reads': "قراءات اللوحات",
  'pv.class.vehicle_photos': "صور المركبات",
  'pv.class.vehicle_movements': "حركات المركبات",
  'pv.class.subject_requests': "طلبات أصحاب البيانات",
  'pv.class.privacy_exports': "تصديرات الخصوصية",
  'pv.class.webhook_deliveries': "تسليمات خطافات الويب",
  'ig.title': "التكاملات والأجهزة",
  'ig.intro': "الاتصال ونتائج الأعمال المؤكدة إشارتان مختلفتان.",
  'ig.simulatorNote': "لا توجد في هذا الإصدار سوى محاكيات ومستقبلات محلية؛ لا يتم الاتصال بأي نظام خارجي، ولا يمثل أي شيء هنا دعماً معتمداً لأي مزوّد.",
  'ig.tabsLabel': "أقسام التكامل",
  'ig.col.action': "الإجراء",
  'ig.secretOnce': "يُعرض مرة واحدة",
  'ig.secretOnceBody': "انسخ هذه القيمة إلى النظام المستقبِل الآن. يحتفظ Passage فقط بقيمة مختصرة أو نسخة مختومة ولن يعرضها مرة أخرى.",
  'ig.secretStored': "لقد حفظتها",
  'ig.con.title': "الموصلات",
  'ig.con.intro': "تتم متابعة سلامة الاتصال ونتائج الأعمال بشكل منفصل؛ تحتاج النتائج غير المعروفة إلى شخص لمطابقتها.",
  'ig.con.add': "إضافة موصل",
  'ig.con.addHint': "الأسرار مراجع إلى مخزن أسرار النشر، وليست قيماً.",
  'ig.con.empty': "لا توجد موصلات مُعدّة.",
  'ig.con.connector': "الموصل",
  'ig.con.connectivity': "الاتصال",
  'ig.con.business': "نتيجة الأعمال",
  'ig.con.open': "فتح",
  'ig.con.name': "الاسم",
  'ig.con.secretRef': "مرجع السر: {name}",
  'ig.con.secretRefHint': "مثال: env:HR_API_TOKEN.",
  'ig.con.create': "إنشاء الموصل",
  'ig.con.secrets': "مراجع الأسرار",
  'ig.con.lastTest': "آخر اختبار اتصال",
  'ig.con.test': "اختبار الاتصال",
  'ig.con.enable': "تفعيل",
  'ig.con.disable': "تعطيل",
  'ig.con.operation': "العملية",
  'ig.con.simulate': "النتيجة المحاكاة",
  'ig.con.run': "تنفيذ العملية",
  'ig.con.history': "سجل العمليات",
  'ig.con.readBack': "ما أظهرته القراءة الراجعة",
  'ig.con.confirmed': "مؤكد",
  'ig.con.failed': "لم يحدث",
  'ig.ad.title': "كتالوج المحوّلات",
  'ig.ad.intro': "يعلن كل محوّل ما يدعمه؛ وأي شيء آخر يعيد \"غير مدعوم\" وليس نجاحاً أبداً.",
  'ig.ad.adapter': "المحوّل",
  'ig.ad.operations': "العمليات المدعومة",
  'ig.ad.validation': "التحقق",
  'ig.ad.none': "لا شيء بعد",
  'ig.business.unknownCount': { zero: "لا نتائج غير معروفة", one: "نتيجة واحدة غير معروفة", two: "نتيجتان غير معروفتين", few: "{count} نتائج غير معروفة", many: "{count} نتيجة غير معروفة", other: "{count} نتيجة غير معروفة" },
  'ig.dev.title': "حالة الأجهزة",
  'ig.dev.intro': "الأكشاك والطابعات والماسحات والقارئات. الاتصال ليس دليلاً على نجاح طباعة بطاقة أو مسح.",
  'ig.dev.kind': "نوع الجهاز",
  'ig.dev.name': "اسم الجهاز",
  'ig.dev.add': "تسجيل الجهاز",
  'ig.dev.empty': "لا توجد أجهزة مسجلة.",
  'ig.dev.device': "الجهاز",
  'ig.dev.lastJob': "نتيجة آخر مهمة",
  'ig.dev.revoke': "إلغاء",
  'ig.dev.revoked': "ملغى",
  'ig.dev.revokeReason': "أُلغي من عرض حالة الأجهزة",
  'ig.dev.foot': "يظهر الجهاز غير متصل عندما تكون آخر نبضة له أقدم من حد التقادم.",
  'ig.dev.pairingCode': "رمز الإقران لـ {name}",
  'ig.wh.title': "اشتراكات خطافات الويب",
  'ig.wh.intro': "أحداث موقّعة من التغييرات المؤكدة فقط. تزيل الجهات المستقبلة التكرار باستخدام معرّف الحدث.",
  'ig.wh.empty': "لا توجد اشتراكات.",
  'ig.wh.subscription': "الاشتراك",
  'ig.wh.events': "أنواع الأحداث",
  'ig.wh.deliveries': "التسليمات",
  'ig.wh.secretHint': "السر …{hint}",
  'ig.wh.counts': "{pending} معلّق · {delivered} مُسلَّم · {dead} متوقف",
  'ig.wh.lastVerification': "التحقق: {outcome} · {at}",
  'ig.wh.log': "سجل التسليم",
  'ig.wh.verify': "التحقق من نقطة الاستقبال",
  'ig.wh.rotate': "تدوير السر",
  'ig.wh.pause': "إيقاف مؤقت",
  'ig.wh.resume': "استئناف",
  'ig.wh.disable': "تعطيل",
  'ig.wh.new': "اشتراك جديد",
  'ig.wh.newHint': "يجب أن تجيب نقطة الاستقبال على تحدٍّ موقّع قبل بدء التسليم.",
  'ig.wh.name': "الاسم",
  'ig.wh.url': "عنوان نقطة الاستقبال",
  'ig.wh.urlHint': "https فقط؛ تُرفض العناوين الداخلية وعناوين البيانات الوصفية.",
  'ig.wh.create': "إنشاء الاشتراك",
  'ig.wh.signingSecret': "سر توقيع خطاف الويب",
  'ig.wh.noDeliveries': "لا توجد تسليمات بعد.",
  'ig.wh.attempts': { zero: "لا محاولات", one: "محاولة واحدة", two: "محاولتان", few: "{count} محاولات", many: "{count} محاولة", other: "{count} محاولة" },
  'ig.wh.inspect': "فحص",
  'ig.wh.replay': "إعادة الإرسال",
  'ig.wh.replayReason': "أعيد الإرسال من سجل التسليم",
  'ig.cl.title': "عملاء واجهة البرمجة",
  'ig.cl.intro': "عملاء على مستوى المؤسسة. النطاقات صلاحيات؛ والإجراءات المخصصة للأشخاص لا تتاح للعملاء أبداً.",
  'ig.cl.openapi': "وصف الواجهة (OpenAPI)",
  'ig.cl.empty': "لا يوجد عملاء.",
  'ig.cl.client': "العميل",
  'ig.cl.scopes': "النطاقات",
  'ig.cl.scopesHint': "إجراءات مفصولة بفواصل، مثل site.read, visit.read.site.",
  'ig.cl.tokens': "الرموز",
  'ig.cl.rate': "{count} طلب في الدقيقة",
  'ig.cl.expires': "ينتهي {at}",
  'ig.cl.lastUsed': "آخر استخدام {at}",
  'ig.cl.rotate': "تدوير الرمز",
  'ig.cl.disable': "تعطيل العميل",
  'ig.cl.disableReason': "عُطّل من عرض عملاء واجهة البرمجة",
  'ig.cl.new': "عميل جديد",
  'ig.cl.newHint': "يُعرض الرمز مرة واحدة وتنتهي صلاحيته؛ دوّره قبل انتهائها.",
  'ig.cl.name': "اسم العميل",
  'ig.cl.create': "إنشاء العميل",
  'ig.cl.token': "رمز الواجهة لـ {name}",
  'ig.tab.connectors': "الموصلات",
  'ig.tab.devices': "الأجهزة",
  'ig.tab.webhooks': "خطافات الويب",
  'ig.tab.clients': "عملاء الواجهة",
  'ig.transport.connected': "متصل",
  'ig.transport.degraded': "متدهور",
  'ig.transport.disconnected': "غير متصل",
  'ig.transport.never_connected': "لم يتصل قط",
  'ig.business.confirmed': "مؤكد",
  'ig.business.attention': "يحتاج إلى متابعة",
  'ig.business.unknown': "نتيجة غير معروفة",
  'ig.business.none': "لا عمليات بعد",
  'ig.outcome.confirmed': "مؤكد",
  'ig.outcome.failed': "فشل",
  'ig.outcome.unknown': "غير معروف",
  'ig.outcome.unsupported': "غير مدعوم",
  'ig.op.test_connection': "اختبار الاتصال",
  'ig.op.read_state': "قراءة الحالة",
  'ig.op.sync_people': "مزامنة الأشخاص",
  'ig.op.issue': "إصدار",
  'ig.op.revoke': "إلغاء",
  'ig.op.observe': "رصد",
  'ig.op.send': "إرسال",
  'ig.op.print': "طباعة",
  'ig.ad.v.simulator': "محاكي (للتطوير فقط)",
  'ig.ad.v.unvalidated': "غير متحقق منه",
  'ig.con.status.draft': "مسودة",
  'ig.con.status.enabled': "مفعّل",
  'ig.con.status.disabled': "معطّل",
  'ig.dev.kind.printer': "طابعة بطاقات",
  'ig.dev.kind.scanner': "ماسح",
  'ig.dev.kind.reader': "قارئ مستندات",
  'ig.dev.kind.encoder': "مرمّز بطاقات",
  'ig.dev.kind.edge_agent': "وكيل طرفي",
  'ig.dev.kind.kiosk': "كشك",
  'ig.job.completed': "مكتمل",
  'ig.job.failed': "فشل",
  'ig.job.unknown': "غير معروف",
  'ig.wh.status.pending_verification': "بانتظار التحقق",
  'ig.wh.status.active': "نشط",
  'ig.wh.status.paused': "متوقف مؤقتاً",
  'ig.wh.status.disabled': "معطّل",
  'ig.wh.dstatus.pending': "معلّق",
  'ig.wh.dstatus.delivered': "مُسلَّم",
  'ig.wh.dstatus.dead': "متوقف نهائياً",
  'ig.wh.dstatus.cancelled': "ملغى",
  'ig.wh.outcome.delivered': "مُسلَّم",
  'ig.wh.outcome.rejected': "مرفوض",
  'ig.wh.outcome.timeout': "انتهت المهلة (غير معروف)",
  'ig.wh.outcome.network_error': "خطأ في الشبكة",
  'ig.wh.outcome.blocked_destination': "الوجهة مرفوضة",
  'ig.cl.status.active': "نشط",
  'ig.cl.status.disabled': "معطّل",
  'ig.cl.token.active': "نشط",
  'ig.cl.token.expired': "منتهي",
  'ig.cl.token.revoked': "ملغى",
  'ig.event.visit.created': "تم التخطيط لزيارة (مسودة أو مُقدَّمة).",
  'ig.event.visit.submitted': "تم تقديم زيارة للموافقة.",
  'ig.event.visit.approved': "تمت الموافقة على جميع مراحل الموافقة لمشارك واحد. الموافقة ليست حضوراً أو وصولاً.",
  'ig.event.visit.rejected': "رفضت إحدى مراحل الموافقة مشاركاً.",
  'ig.event.visit.cancelled': "أُلغيت زيارة. لا يعني الإلغاء أن أحداً غادر.",
  'ig.event.visitor.checked_in': "تم رصد وصول (واقعة حضور؛ ليست حالة موافقة أو بطاقة).",
  'ig.event.visitor.checked_out': "تم رصد مغادرة. إلغاء البطاقة واقعة منفصلة وقد تكون معلّقة.",
  'ig.event.credential.revocation_requested': "طُلب إلغاء البطاقة المنطقية. تُبلَّغ نتيجة المزوّد بشكل منفصل.",
  'ig.event.delivery.handed_over': "تم تسجيل تسليم شحنة أو رفضها في المكتب.",
  'ig.event.vehicle.entered': "تم رصد دخول مركبة وتسجيله.",
  'ig.event.vehicle.exited': "تم رصد خروج مركبة وتسجيله.",
  'ig.event.vehicle.expected': "أُرفقت مركبة متوقعة بزيارة (توقّع وليس إذناً).",
};
